import React, { useState, useEffect, useRef } from "react";
import { useAppContext } from "../../context/AppContext";
import { LanguageDetails } from "../../utils/types";
import { trackPixelEvent } from "../../utils/pixel";

export default function LanguageToggler({ onSelect }) {
  const { language, toggleLanguage } = useAppContext();
  const [showLanguages, setShowLanguages] = useState(false);
  const menuRef = useRef(null);

  const toggleLanguages = () => {
    setShowLanguages(!showLanguages);
  };

  const changeLanguage = (language) => {
    trackPixelEvent(`ChangedLanguageTo${language}`)
    toggleLanguage(language);
    setShowLanguages(false);
    onSelect?.();
  };

  // Close the menu if clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowLanguages(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <button
        className="p-1 rounded text-pink hover:bg-beige hover:text-white"
        onClick={toggleLanguages}
      >
        <span className="flex">
          {LanguageDetails.find((lang) => lang.key === language)?.abbreviation.toUpperCase()}
        </span>
      </button>

      {showLanguages && (
        <ul className="absolute md:right-0 -right-10 bg-white mt-1 opacity-100 border rounded-lg shadow-lg w-fit z-20 cursor-pointer">
          {LanguageDetails.map((lang) => (
            <li key={lang.key} className="hover:text-black">
              <a
                onClick={() => changeLanguage(lang.key)}
                className="block hover:bg-beige hover:text-white px-4 py-2 rounded"
              >
                {lang.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
